import type { ICartProduct, PBMProgram } from '@/types';

import type { CartSyncPayload } from './cart-sync.types';

function pbmMetadataForSync(
  item: ICartProduct,
): Record<string, unknown> | undefined {
  const pbm = item.pbm_info;
  if (!pbm?.flag) return undefined;
  const unit =
    typeof item.calculated_sale_price === 'number' &&
    Number.isFinite(item.calculated_sale_price)
      ? item.calculated_sale_price
      : typeof item.sale_price === 'number' && Number.isFinite(item.sale_price)
        ? item.sale_price
        : undefined;
  const meta: Record<string, unknown> = {
    flag: true,
    cpf: pbm.cpf,
    sale_price_id: pbm.sale_price_id,
    quantity: pbm.quantity,
  };
  if (unit !== undefined) {
    meta.pbm_sale_price = unit;
  }
  if (pbm.program && typeof pbm.program === 'object') {
    const prog = pbm.program as PBMProgram;
    const pr: Record<string, unknown> = {
      id: prog.id,
      name: prog.name,
    };
    if (typeof prog.register_url === 'string' && prog.register_url.length > 0) {
      pr.register_url = prog.register_url;
    }
    if (
      prog.middleware &&
      typeof prog.middleware.id === 'number' &&
      Number.isFinite(prog.middleware.id) &&
      typeof prog.middleware.slug === 'string' &&
      prog.middleware.slug.length > 0
    ) {
      pr.middleware = {
        id: prog.middleware.id,
        slug: prog.middleware.slug,
      };
    }
    meta.program = pr;
  }
  return meta;
}

export function serializeCartForSync(items: ICartProduct[]): CartSyncPayload {
  const now = new Date().toISOString();
  return {
    items: items.map((item) => {
      const last_modified_at = item.cart_line_updated_at ?? now;
      const metadata: Record<string, unknown> = {
        ...(pbmMetadataForSync(item) ?? {}),
      };
      if (item.from_prescription) {
        metadata.from_prescription = true;
      }
      const hasMetadata = Object.keys(metadata).length > 0;
      return {
        product_id: item.product_id,
        sku: item.id,
        quantity: item.quantity ?? 1,
        last_modified_at,
        ...(hasMetadata ? { metadata } : {}),
      };
    }),
  };
}
